// Utility functions for theme-related styling

/**
 * Get button border radius based on theme button style
 * @param {string} buttonStyle - The button style from theme ('square', 'rounded', 'pill')
 * @returns {string} - CSS border radius value
 */
export const getButtonBorderRadius = (buttonStyle) => {
  switch (buttonStyle) {
    case "square":
      return "0px"
    case "rounded":
      return "12px"
    case "pill":
      return "50px"
    default:
      return "12px" // Default to rounded
  }
}

/**
 * Get button classes based on theme button style
 * @param {string} buttonStyle - The button style from theme ('square', 'rounded', 'pill')
 * @returns {string} - Tailwind CSS classes for border radius
 */
export const getButtonClasses = (buttonStyle) => {
  switch (buttonStyle) {
    case "square":
      return "rounded-none"
    case "rounded":
      return "rounded-xl"
    case "pill":
      return "rounded-full"
    default:
      return "rounded-xl" // Default to rounded
  }
}

/**
 * Apply theme button styling to a style object
 * @param {Object} baseStyle - Base style object
 * @param {Object} theme - Theme object containing buttonStyle and borderRadius
 * @returns {Object} - Style object with applied button styling
 */
export const applyButtonTheme = (baseStyle, theme) => {
  const borderRadius = theme?.borderRadius || getButtonBorderRadius(theme?.buttonStyle)

  return {
    ...baseStyle,
    borderRadius: borderRadius
  }
}
